var map = {
	"./pitch_black.png": "RrAv",
	"./pitch_black_HQ.png": "qoTF",
	"./pitch_black_old.png": "o2/A",
	"./pitch_black_wide.png": "HSxZ",
	"./pitch_blue.png": "FInX",
	"./pitch_blue_HQ.png": "xxDF",
	"./pitch_blue_old.png": "yvzL",
	"./pitch_blue_vertical.png": "KXn4",
	"./pitch_blue_wide.png": "C2pq",
	"./pitch_green.png": "t70D",
	"./pitch_green_HQ.png": "nQsG",
	"./pitch_green_old.png": "Sqbw",
	"./pitch_green_vertical.png": "Pjac",
	"./pitch_green_wide.png": "HZhf",
	"./pitch_grey.png": "d54U",
	"./pitch_grey_wide.png": "xBif",
	"./pitch_white.png": "lp7q",
	"./pitch_white_old.png": "Kn8P",
	"./pitch_white_wide.png": "mYbJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MFjp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/pitch_.*\.png$
// module id = MFjp
// module chunks = 94